import { CodeTypeAct } from 'civil-status/constants/code-type-act';
import { initialValuesSections } from 'civil-status/constants/initial-values-step';
import { SectionVM } from 'civil-status/view-models/step-form';

export const clearSection = (dataSection?: SectionVM): SectionVM => {
  // mantiene i dati necessari per i salvataggi ed i diversi controlli
  return {
    ...initialValuesSections,
    isRequiredFromOtherAccordion: dataSection?.isRequiredFromOtherAccordion,
    configuration: dataSection?.configuration,
    codeSection: dataSection?.codeSection,
    typeSection: dataSection?.typeSection,
    typePersistence: dataSection?.typePersistence,
    typePresence: dataSection?.typePresence,
    idCertSanitario: dataSection?.idCertSanitario,
    idDatiEventoRiconoscimento: dataSection?.idDatiEventoRiconoscimento,
    idEnteDichiarante: dataSection?.idEnteDichiarante,
    idCertificato: dataSection?.idCertificato,
    idImpedimento: dataSection?.idImpedimento,
    idAttoCollegato: dataSection?.idAttoCollegato,
    idConsenso: dataSection?.idConsenso,
    idLuogo: dataSection?.idLuogo,
    riconoscimentoList: dataSection?.riconoscimentoList,
    typeAct: CodeTypeAct.attoCartaceo,
  };
};

export const clearSectionMomentary = (): SectionVM => {
  // elimina i dati necessari per il colloquio con il BE
  // utilizzare per controlli momentanei
  return {
    configuration: undefined,
    codeSection: undefined,
    typeSection: undefined,
    typePersistence: undefined,
    typePresence: undefined,
    idCertSanitario: undefined,
    idDatiEventoRiconoscimento: undefined,
    idEnteDichiarante: undefined,
    idCertificato: undefined,
    idImpedimento: undefined,
    idAttoCollegato: undefined,
    idLuogo: undefined,
    idConsenso: undefined,
    idCertificatoUnioneCivile: undefined,
    riconoscimentoList: undefined,
    eventType: undefined,
    conditionsItem: undefined, // è un campo inizializzato con uno specifico valore
    opposition: undefined, // è un campo inizializzato con uno specifico valore
    genericImpediment: undefined, // è un campo inizializzato con uno specifico valore
    typeActToTranscribed: undefined, // è un campo inizializzato con uno specifico valore
    ageDefect: undefined, // è un campo inizializzato con uno specifico valore
    relationship: undefined, // è un campo inizializzato con uno specifico valore
    typeExtremesDecree: undefined, // è un campo inizializzato con uno specifico valore
    // annullare i flag di gestione i quali non vengono salvati quindi non sono utili al fine del controllo
    isDatePresumed: undefined,
    isForeign: undefined,
    isInterestedPresent: undefined,
    typeAct: undefined,
    isSaved: undefined,
    isWithInterprete: undefined,
  };
};
